import editableEnhancer from 'app/general/editableEnhancer';
import {ViewProcedureMetaData} from 'app/procedures/components/ViewProcedureMetaData';

import {EditProcedureMetaData} from './EditProcedureMetaData';
const EditableProcedureMetaData = editableEnhancer(
  ViewProcedureMetaData,
  EditProcedureMetaData
);
export default EditableProcedureMetaData;
